// extracted by mini-css-extract-plugin
export default {"container":"AiModelsManager_container__mVcXx","toolbar":"AiModelsManager_toolbar__cMJaX","list":"AiModelsManager_list__EAY7a","table":"AiModelsManager_table__TUOsl"};